export const INITIAL_COMPONENTS = [
  // ── Primitives ─────────────────────────────────────────────────────────────
  {
      label: 'Container',
      section: 'Primitives',
      type: 'Box',
      defaultProps: {},
      defaultSize: { w: 100, h: 100 },
      defaultComponents: []
  },
  {
      label: 'Text',
      section: 'Primitives',
      type: 'Box',
      defaultProps: {},
      defaultSize: { w: 150, h: 40 },
      defaultComponents: [{ type: 'Text', props: { content: 'Label text', fontSize: 16 } }]
  },
  {
      label: 'Button',
      section: 'Primitives',
      type: 'Box',
      defaultProps: {},
      defaultSize: { w: 120, h: 40 },
      defaultComponents: [
          { type: 'Text', props: { content: 'Button', textAlign: 'center', fontWeight: 'bold' } },
          { type: 'Button', props: {} }
      ]
  },
  {
      label: 'Image',
      section: 'Primitives',
      type: 'Box',
      defaultProps: {},
      defaultSize: { w: 100, h: 100 },
      defaultComponents: [{ type: 'Image', props: { src: 'https://picsum.photos/200/200', objectFit: 'cover' } }]
  },
  {
      label: 'Input',
      section: 'Primitives',
      type: 'Box',
      defaultProps: {},
      defaultSize: { w: 160, h: 40 },
      defaultComponents: [{ type: 'Input', props: { placeholder: 'Type here...' } }]
  },

  // ── Aldoo-RA Components ────────────────────────────────────────────────────
  {
      label: 'Image',
      section: 'Aldoo-RA',
      type: 'Box',
      defaultProps: {},
      defaultSize: { w: 120, h: 120 },
      defaultComponents: [{ type: 'AldooImage', props: { src: '', id: '', variant: 'md', alt: 'image' } }]
  },
  {
      label: 'Button',
      section: 'Aldoo-RA',
      type: 'Box',
      defaultProps: {},
      defaultSize: { w: 150, h: 40 },
      defaultComponents: [{ type: 'AldooButton', props: { children: 'Button', variant: 'admin_primary' } }]
  },
  {
      label: 'Input',
      section: 'Aldoo-RA',
      type: 'Box',
      defaultProps: {},
      defaultSize: { w: 240, h: 60 },
      defaultComponents: [{ type: 'AldooInput', props: { placeholder: 'Enter text...', variant: 'admin' } }]
  },
  {
      label: 'Checkbox',
      section: 'Aldoo-RA',
      type: 'Box',
      defaultProps: {},
      defaultSize: { w: 160, h: 36 },
      defaultComponents: [{ type: 'AldooCheckbox', props: { label: 'Option', variant: 'admin' } }]
  },
  {
      label: 'Dropdown',
      section: 'Aldoo-RA',
      type: 'Box',
      defaultProps: {},
      defaultSize: { w: 200, h: 40 },
      defaultComponents: [{ type: 'AldooDropdownSelect', props: { placeholder: 'Select...', variant: 'admin' } }]
  },
  {
      label: 'Menu',
      section: 'Aldoo-RA',
      type: 'Box',
      defaultProps: {},
      defaultSize: { w: 320, h: 48 },
      defaultComponents: [{ type: 'AldooMenu', props: { renderAs: 'hlist', menuConfig: null } }]
  },
  {
      label: 'Data Table',
      section: 'Aldoo-RA',
      type: 'Box',
      defaultProps: {},
      defaultSize: { w: 400, h: 200 },
      defaultComponents: [{ type: 'AldooDataTable', props: { variant: 'admin' } }]
  },
  {
      label: 'Panel',
      section: 'Aldoo-RA',
      type: 'Box',
      defaultProps: {},
      defaultSize: { w: 300, h: 120 },
      defaultComponents: [{ type: 'AldooPanel', props: { title: 'Panel', variant: 'default', collapsible: true, defaultOpen: true } }]
  },
  {
      label: 'Progress Bar',
      section: 'Aldoo-RA',
      type: 'Box',
      defaultProps: {},
      defaultSize: { w: 280, h: 36 },
      defaultComponents: [{ type: 'AldooProgressBar', props: { progress: 0.5, variant: 'default' } }]
  },
  {
      label: 'Spinner',
      section: 'Aldoo-RA',
      type: 'Box',
      defaultProps: {},
      defaultSize: { w: 60, h: 60 },
      defaultComponents: [{ type: 'AldooSpinner', props: { variant: 'primary', size: 'md' } }]
  },
  {
      label: 'Tabs',
      section: 'Aldoo-RA',
      type: 'Box',
      defaultProps: {},
      defaultSize: { w: 360, h: 44 },
      defaultComponents: [{ type: 'AldooTabs', props: { variant: 'default', orientation: 'horizontal', size: 'medium' } }]
  },
  {
      label: 'Toggle Switch',
      section: 'Aldoo-RA',
      type: 'Box',
      defaultProps: {},
      defaultSize: { w: 80, h: 36 },
      defaultComponents: [{ type: 'AldooToggleSwitch', props: { variant: 'default', isOn: false } }]
  },
  {
      label: 'Typography',
      section: 'Aldoo-RA',
      type: 'Box',
      defaultProps: {},
      defaultSize: { w: 200, h: 32 },
      defaultComponents: [{ type: 'AldooTypography', props: { children: 'Text content', variant: 'txt' } }]
  },
  {
      label: 'Date Picker',
      section: 'Aldoo-RA',
      type: 'Box',
      defaultProps: {},
      defaultSize: { w: 240, h: 44 },
      defaultComponents: [{ type: 'AldooDatePicker', props: { variant: 'default' } }]
  },
  {
      label: 'Date Range',
      section: 'Aldoo-RA',
      type: 'Box',
      defaultProps: {},
      defaultSize: { w: 240, h: 44 },
      defaultComponents: [{ type: 'AldooDateFilterDropdown', props: { label: 'Date Range', variant: 'default' } }]
  },
  {
      label: 'Drop Zone',
      section: 'Aldoo-RA',
      type: 'Box',
      defaultProps: {},
      defaultSize: { w: 240, h: 120 },
      defaultComponents: [{ type: 'AldooDropZone', props: { maxFiles: 1 } }]
  },
];
